import { Link } from "react-router-dom"
import styled from "styled-components"

export const WeightChangedNotificationWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  z-index: var(--z-index-notification-overlay);

  border-radius: var(--spacing_s, 8px) var(--spacing_s, 8px) 0px 0px;
  border-bottom: 1px solid rgba(238, 238, 238, 0.93);
  background: #fcfcfc;
  box-shadow: 0px -7.05px 9.612px -4.486px rgba(58, 53, 65, 0.2),
    0px -15.38px 24.351px 1.922px rgba(58, 53, 65, 0.14),
    0px -5.77px 29.477px 5.126px rgba(58, 53, 65, 0.12);

  max-width: var(--app-max-width);
  margin: 0 auto;

  @keyframes slideInFromBottom {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }
  animation: slideInFromBottom 0.3s ease-out;
`

export const WeightChangedNotificationContent = styled.div`
  position: relative;
  padding: 24px;
`

export const IconWrapper = styled.div`
  display: flex;
  width: 34px;
  height: 34px;
  padding: 7px;
  justify-content: center;
  align-items: center;
  border-radius: 16.837px;
  background: var(--Schemes-Primary-Container-Variant, #cceded);
`
export const WeightChangedTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  line-height: 160%;
`

export const WeightChangedText = styled.p`
  margin: 0;
  font-size: 14px;
`

export const WeightChangedTextStrong = styled.span`
  font-weight: 600;
`

export const ViewGoalLink = styled(Link)`
  color: var(--Schemes-Primary-Container-Variant-2, #0fbdd4);
  font-weight: 600;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
`
